/* zf-product-card: quick add for single-variant products ([data-zf-quick-add="variantId"]). */
(function () {
  if (window.zfQuickAddBound) return;
  window.zfQuickAddBound = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zf-quick-add]');
    if (!btn || btn.disabled || typeof window.zfAddToCart !== 'function') return;
    e.preventDefault();
    const atc = btn.closest('.zf-card-product__atc');
    const err = (atc ? atc.parentElement : btn.parentElement).querySelector('.zf-card-product__error, [data-zf-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.setAttribute('aria-busy', 'true');
    try {
      const box = btn.parentElement.querySelector('[data-zf-qty]');
      const qty = box ? Math.max(1, parseInt(box.value, 10) || 1) : 1;
      await window.zfAddToCart([{ id: Number(btn.dataset.zfQuickAdd), quantity: qty }], btn);
    } catch (error) {
      if (err) { err.textContent = error.message; err.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
